import type { ReactNode } from 'react';
import dynamic from 'next/dynamic';
import Head from 'next/head';

import g from 'src/constants/global';

const ErrorPageContainer = dynamic(() => import('src/containers/Custom/ErrorPage'));

function Error({ statusCode }: { statusCode: number | string }) {
	let errorState = g.ERRORPAGE[500];
	if (statusCode === 404) {
		errorState = g.ERRORPAGE[404];
	}

	const { title, description } = errorState;
	return (
		<>
			<Head>
				<title>{title}</title>
			</Head>
			<ErrorPageContainer title={title} description={description} />
		</>
	);
}

Error.getInitialProps = ({ res, err }: { res: any; err: any }) => {
	const errStatusCode = err ? err.statusCode : 500;
	const statusCode = res ? res.statusCode : errStatusCode;
	return { statusCode };
};

Error.getLayout = ({ children }: { children: ReactNode }) => children;

export default Error;
